import type { ButtonIconName } from '@/components/button/button-icon.type';
import { SvgImages } from '@/utils/svg-images';
import { ROUTES } from '@/consts/routes.const';

export const ERROR_STATE_CODE = [
  'unauthorized',
  'forbidden',
  'notFound',
  'internalServerError',
  'serviceUnavailable',
  'oldBrowser',
] as const;
export type ErrorStateCode = (typeof ERROR_STATE_CODE)[number];

export interface ErrorStateButtonParams {
  text: string;
  icon?: ButtonIconName;
  href?: string;
  routerLink?: string | string[];
}

export const errorStateCodeTitle: Record<ErrorStateCode, string> = {
  unauthorized: 'Вы не авторизованы',
  forbidden: 'У вас нет доступа к этой странице',
  notFound: 'Страница не найдена',
  internalServerError: 'Ошибка сервера',
  serviceUnavailable: 'Сервер временно недоступен',
  oldBrowser: 'Ваш браузер устарел',
};

export const errorStateCodeImage: Record<ErrorStateCode, SvgImages> = {
  unauthorized: SvgImages.error401,
  forbidden: SvgImages.error403,
  notFound: SvgImages.error404,
  internalServerError: SvgImages.error500,
  serviceUnavailable: SvgImages.error503,
  oldBrowser: SvgImages.error503,
};

const goToRootButton: ErrorStateButtonParams = {
  text: 'На главную страницу',
  icon: 'home',
  routerLink: ROUTES.home,
};

export const errorStateBackBtnParams: Partial<Record<ErrorStateCode, ErrorStateButtonParams>> = {
  forbidden: {
    text: 'В личный кабинет',
    icon: 'log-in',
  },
};

export const errorStateSubmitBtnParams: Partial<Record<ErrorStateCode, ErrorStateButtonParams>> = {
  serviceUnavailable: goToRootButton,
  notFound: goToRootButton,
  forbidden: goToRootButton,
  internalServerError: goToRootButton,
  unauthorized: {
    text: 'Авторизоваться',
    icon: 'log-in',
  },
  oldBrowser: {
    text: 'Перейти на старую версию приложения',
    routerLink: ROUTES.home,
  },
};
